import React, {useEffect} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import Background from "../../../assets/Ocean-bg.jpg";
import {
	Button,
	Container,
	Paper,
	Typography
} from "@mui/material";
import clsx from "clsx";
import Grid from "@mui/material/Grid";
import logo from "../../../assets/v2/Logo-Orca.svg";
import {LoginStyle} from "../../../styles/pages/auth/LoginStyle";
import {useHistory} from "react-router-dom";


const TicketScadutoPage = () => {
	const classes = LoginStyle();
	const baseClasses = BaseStyle();
	let history = useHistory();
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
		<React.Fragment>
			<Container maxWidth={"sm"} className={classes.container} component={"main"}>
				<Paper variant={"elevation"}
				       className={clsx(classes.paper404, baseClasses.roundBorder, baseClasses.transparent30, baseClasses.blurred20)}
				       elevation={18} component={"article"} style={{height: 400}}>
					<Grid container spacing={2}>
						<Grid item xs={12} className={classes.flexGrid}>
							<img className={classes.logo} src={logo} alt={"logo"}/>
						</Grid>
						<Grid item xs={12}>
							<Typography className={classes.title} variant={"h3"}><b>Ticket scaduto</b></Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography className={classes.subTitle} variant={"body1"}>
								Ops, questo ticket è scaduto!<br/> Nel caso tu abbia bisogno di contattare nuovamente l'Asl apri un
								nuovo ticket!
							</Typography>
						</Grid>
						<Grid item xs={12} className={baseClasses.flexCenter}>
							<Button className={clsx(baseClasses.roundBorder, baseClasses.margin2, baseClasses.blurred20)}
							        style={{borderRadius: 24}}
							        size={"small"} variant={"contained"} color={"primary"}
							        onClick={() => history.push("/contattaci")}>
								Apri un ticket!
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</Container>
		</React.Fragment>
	);
}

export default React.memo(TicketScadutoPage);
